import React, { useState, useEffect } from "react";
// import "./ImageSlider.css";

function WellcomeSlider({ images, slideInterval }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((currentSlide + 1) % images.length);
    }, slideInterval);

    return () => clearInterval(interval);
  }, [currentSlide, images.length, slideInterval]);

  return (
    <div className="slider-container">
      {images.map((image, index) => (
        <div
          className={`slide ${index === currentSlide ? "active" : ""}`}
          key={index}
        >
          <img className="sImage" src={image} alt={`Slide ${index}`} />
        </div>
      ))}
    </div>
  );
}

export default WellcomeSlider;
